import React, { lazy, Suspense } from 'react';

const FormulaEditorView = lazy(() => import('./FormulaEditor.view.jsx'));

const FormulaEditor = (props) => (
  <Suspense fallback={<div className="editor-placeholder" />}>
    <FormulaEditorView {...props} />
  </Suspense>
);

export default FormulaEditor;